import { compose, prop } from 'ramda';
import { createSelector } from 'reselect';

import contacts from 'features/views/contacts';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSelectedContactId = compose(prop('selectedContactId'), getRoot);

export const getSelectedContact = createSelector(
	contacts.selectors.getAllContacts,
	getSelectedContactId,
	(contacts, selectedId) => contacts[selectedId],
);
